"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDialogProps = void 0;
var _openBackInStockNotificationDialog = require("@ori-events/open-back-in-stock-notification-dialog");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
const useDialogProps = ({
  onClose,
  onOpen,
  open
}) => {
  const [productCode, setProductCode] = (0, _react.useState)('');
  const successClose = (0, _react.useCallback)(() => {
    setTimeout(() => {
      onClose();
    }, 5000);
  }, [onClose]);
  const openDialog = (0, _react.useCallback)(event => {
    const {
      code
    } = event.detail;
    onOpen();
    setProductCode(code);
  }, [onOpen]);
  const events = (0, _react.useMemo)(() => [{
    name: _openBackInStockNotificationDialog.Name,
    listener: openDialog
  }], [openDialog]);
  (0, _presentationHooks.useGlobalEvents)(events);
  return {
    open,
    productCode,
    close: onClose,
    successClose
  };
};
exports.useDialogProps = useDialogProps;